import { replaceAllowCharacter } from '@helpers/@utils/replace-allow-characters';
import { Textarea } from '@mis/sushi-tailwind-react';
import React from 'react';

export type InputTextareaProps = Omit<React.ComponentProps<typeof Textarea>, 'status'> & {
  allowOnly?: 'en' | 'th';
  status?: React.ComponentProps<typeof Textarea>['status'];
  viewOnly?: boolean;
};

const InputTextarea: React.FC<InputTextareaProps> = ({ allowOnly, onChange, viewOnly, ...props }) => {
  const onChangeValue = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    if (!allowOnly || !e.target.value) return onChange?.(e);
    const event = replaceAllowCharacter(e, allowOnly);
    onChange?.(event);
  };

  if (viewOnly) {
    return (
      <div className="flex h-full flex-row whitespace-pre-line border-b border-secondary-800 px-3 py-1">
        <span>{props.value === null ? '' : props.value?.toString()}</span>
      </div>
    );
  }

  return (
    <Textarea
      data-testid={props.id}
      autoComplete="off"
      readOnly={viewOnly}
      showCount={props.maxLength !== undefined}
      {...props}
      value={props.value === null ? '' : props.value}
      onChange={onChangeValue}
    />
  );
};

export default InputTextarea;
